import React from 'react';
import { Card, CardContent, Box, Skeleton } from '@mui/material';

/**
 * Project Card Skeleton
 * Loading state for project cards
 */
const ProjectCardSkeleton = () => {
  return (
    <Card
      sx={{
        height: '100%',
        borderRadius: 2,
        border: '1px solid #e0e0e0'
      }}
    >
      <CardContent sx={{ p: 3 }}>
        {/* Header */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <Skeleton variant="text" width="70%" height={32} />
          <Skeleton variant="rounded" width={100} height={28} />
        </Box>

        {/* Location */}
        <Skeleton variant="text" width="50%" height={20} sx={{ mb: 2 }} />

        {/* Divider */}
        <Box sx={{ height: 1, backgroundColor: '#e0e0e0', my: 2 }} />

        {/* Budget and Contractor */}
        <Skeleton variant="text" width="60%" height={20} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="55%" height={20} sx={{ mb: 2 }} />

        {/* Progress Bar */}
        <Box sx={{ mb: 1 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
            <Skeleton variant="text" width={60} height={16} />
            <Skeleton variant="text" width={40} height={16} />
          </Box>
          <Skeleton variant="rounded" width="100%" height={8} sx={{ borderRadius: 4 }} />
          <Skeleton variant="text" width="70%" height={14} sx={{ mt: 0.5 }} />
        </Box>

        {/* Button */}
        <Skeleton
          variant="rounded"
          width="100%"
          height={42}
          sx={{ mt: 3, borderRadius: 1.5 }}
        />
      </CardContent>
    </Card>
  );
};

/**
 * Multiple Skeletons Grid
 */
export const ProjectCardSkeletonGrid = ({ count = 6 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <ProjectCardSkeleton key={index} />
      ))}
    </>
  );
};

export default ProjectCardSkeleton;
